import { Button, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useLogin } from 'apollo/mutations/Authentication';
import { AuthContext } from 'context/auth/AuthContext';
import { Types } from 'context/auth/AuthReducer';
import React, { useContext, useState } from 'react';

const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

interface ILoginResponse {
    data?: {
        login: {
            access_token: string;
            expires_in: number;
            user: {
                name: string;
                email: string;
                id: string;
                __typename: string;
            };
            __typename: string;
        };
    };
}

const LoginForm = () => {
    const classes = useStyles();
    const [error, setError] = useState<Error>();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [login] = useLogin({
        variables: {
            username: '',
            password: '',
        },
    });
    const { dispatch } = useContext(AuthContext);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const { email, password } = formData;

        return login({
            variables: {
                username: email,
                password: password,
            },
        })
            .then((res: ILoginResponse) => {
                const { data: { login } = {} } = res;
                if (login) {
                    dispatch({
                        type: Types.Login,
                        payload: {
                            isAuthenticated: true,
                            user: {
                                email: login.user.email,
                                accessToken: login.access_token,
                                name: login.user.name,
                                id: login.user.id,
                            },
                        },
                    });
                }
            })
            .catch((err: Error) => setError(err));
    };

    const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const target = e.target;
        const { name, value, checked, type } = target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    return (
        <form className={classes.form} onSubmit={handleSubmit}>
            <TextField
                variant='outlined'
                margin='normal'
                required
                fullWidth
                id='email'
                label='Email Address'
                name='email'
                autoComplete='email'
                autoFocus
                value={formData.email}
                onChange={handleFormChange}
            />
            <TextField
                variant='outlined'
                margin='normal'
                required
                fullWidth
                name='password'
                label='Password'
                type='password'
                id='password'
                autoComplete='current-password'
                onChange={handleFormChange}
            />
            {/* <FormControlLabel
                control={<Checkbox value='remember' name='remember' color='primary' onChange={handleFormChange} />}
                label='Remember me'
            /> */}
            <Button type='submit' fullWidth variant='contained' color='primary' className={classes.submit}>
                Sign In
            </Button>
            {/* <FormRetrievelActions /> */}

            {error?.message === 'Failed to fetch' && (
                <p>We were unable to reach the server, please check your internet connection and try again.</p>
            )}
            {error && error.message !== 'Failed to fetch' && (
                <p>The credentials were not correct. Try again later or contact ProudNerds for new credentials.</p>
            )}
        </form>
    );
};

export default LoginForm;
